import log from "libs/Utils/log";
import mediator from "libs/mediator";

export default (function() {
  function run(){
    log("ShowMore:init");

    mediator.on("showmore", attachEventListener);
  }

  function attachEventListener() {
    let showMores = document.querySelectorAll('[data-module="show-more"]');

    showMores.forEach(function(element) {
      element.removeEventListener("click", handleShowMoreClick);
      element.removeEventListener("touchstart", handleShowMoreClick);
      element.addEventListener("click", handleShowMoreClick);
      element.addEventListener("touchstart", handleShowMoreClick, {passive: false});
    });
  }

  function handleShowMoreClick(event) {
    event.preventDefault();

    if (event.type === "touchstart") {
      event.stopPropagation();
    }

    let toggleElement = event.target.closest('[data-module="show-more"]');
    if (!toggleElement) return;

    let container = toggleElement.parentElement;
    let description = container.querySelector('[data-module="description"]');

    if (!description) {
      description = toggleElement.previousElementSibling;
    }

    if (!description) return;

    let descriptionClass = description.classList[0];

    if(description.classList.contains(`${descriptionClass}--small`)) {
      description.classList.remove(`${descriptionClass}--small`);

      if (toggleElement.classList.contains('coupon__toggle')) {
        toggleElement.innerHTML = '<i class="roberto-chevron-up"></i> <span>' + toggleElement.getAttribute('data-less-text') + '</span>';
      } else {
        toggleElement.innerHTML = toggleElement.getAttribute('data-less-text');
      }
    } else {
      description.classList.add(`${descriptionClass}--small`);

      if (toggleElement.classList.contains('coupon__toggle')) {
        toggleElement.innerHTML = '<i class="roberto-chevron-down"></i> <span>' + toggleElement.getAttribute('data-more-text') + '</span>';
      } else {
        toggleElement.innerHTML = toggleElement.getAttribute('data-more-text');
      }
    }
  }
  return {
    run: run
  }
})()
